module.exports = __webpack_public_path__ + "static/media/v.bf923ec2.jpg";